module.exports = {"id":"183870","name":"Anthony Mounier","rating":"75","photo":"./data/images/photos/3/183870.png","club":{"name":"Panathinaïkos","logo":"./data/images/clubs/Panathinaikos.png"},"positions":["AD","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AnthonyMounier0.json
// module id = 431
// module chunks = 0